<template>
  <table>
    <tr>
      <td style="width:15%;min-width:100px;">
        <select class="normalInput normalSelect" ref="country_delivery" id="select_delivery" style="background-color: white;">
          <option value = "" selected>{{ $t('menu.selectCountry') }}</option>
          <option v-for="c in [...this.api.COUNTRIES].sort((a, b) => a.name.localeCompare(b.name, 'ko'))" :key="c.code" :value="c.name">
            {{ c.name }}
          </option>
        </select>
      </td>
      <td style="width:100%;">
        <input class="normalInput normalSelect" v-on:keyup.enter="search(1)" ref="tag" id="tag" :placeholder="$t('sentence.noInputAll')" type="text">
      </td>
      <td style="min-width:100px;">
        <Button @click="search(1)" style="width:100%;" :label="$t('menu.search')" raised size="small" />
      </td>
    </tr>
  </table>
  <span id="estimateSearchResult" :key="estimate3Key" >
    <div v-for="(group, key) in groupingOrders" :key="key" class="card" style="width:100%; margin-top: 20px;" >
      <table style="width: 100%;">
        <tr>
          <td style="margin-right: 10px; width: 50%; text-align: left;" >
          <span style="color:red"> {{groupingOrders.get(group[0]).length}}{{ $t('unit.quantity') }} {{ $t('menu.dPrice') }} : <span style="font-weight: bold;">{{ totalDeliveryPrice.get(group[0]).toLocaleString() }}</span>{{ $t('unit.won') }}</span>
          </td>
        </tr>
      </table>
      <DataTable :value="groupingOrders.get(group[0])" stripedRows>
        <template #header>
        </template>
        <Column :header="$t('menu.picture')" style="max-width:60px;">
          <template #body="slotProps">
            <img v-if="slotProps.data.IMG_URL === undefined || slotProps.data.IMG_URL === ''" src="../../assets/logo_big.jpg" alt="GEEK9" style="width:50px;" />
            <img v-else :src="slotProps.data.IMG_URL" alt="GEEK9" style="width:50px;" />
          </template>
        </Column>
        <Column field="NAME" :header="$t('menu.itemName')" style="width:50%"/>
        <Column field="COUNTRY" :header="$t('menu.delivery')" style="min-width:90px;">
          <template #body="slotProps">
            {{ slotProps.data.COUNTRY }} >> {{ slotProps.data.COUNTRY2 ? this.api.getCountryName({country:slotProps.data.COUNTRY2}) : this.api.getCountryName({country:'한국'})  }}
          </template>
        </Column>
        <Column field="URL" :header="$t('menu.url')" style="min-width:60px;">
          <template #body="slotProps">
            <a :href="(slotProps.data.URL).indexOf('http') === -1 ? 'https://' + slotProps.data.URL : slotProps.data.URL" target="_blank" >{{$t('menu.click')}}</a>
          </template>
        </Column>
      </DataTable>
    </div> 
    <br>
    <div style="text-align: center; margin-top: 10px;" v-if="groupingOrders.size !== 0">
      <label @click="paging('prev')" class="link">
        {{ $t('menu.prev') }}
      </label>
      <span style="margin:20px">{{page}}</span>
      <label @click="paging('next')" class="link">
        {{ $t('menu.next') }}
      </label>
    </div>  
  </span>        
</template>

<script>

import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

export default {
  components: {
  },
  setup() {
    const { t } = useI18n()

    let orders = ref([])
    let groupingOrders = new Map()
    let totalDeliveryPrice = new Map()

    return {
      orders, groupingOrders, totalDeliveryPrice, t
    } 
  },  
  data() { 
    return {
      language:'kr',
      page: 1,
      estimate3Key: 0,
      deliverycKey:-1
    }
  },
  methods: {
    async search(page) {
      var country = this.$refs.country_delivery.value; 
      var tag = this.$refs.tag.value
      if(country === '' ) {
        alert(`${this.t('sentence.depatureCountryChoice')}`)
      } else if(tag.indexOf('http') !== -1 || tag.indexOf('www') !== -1 ) {
        this.emitter.emit('confirm', {message: `${this.t('sentence.wrongInfo67')}`, header:this.api.getCookies('page'), icon:'pi pi-exclamation-triangle'}) 
      } else {
        this.emitter.emit('dialog', {flag:true, title:'Loading'})
        const param = {type:"SELECT_DELIVERY_INFO", country: this.api.getCountryName({country:country}), tag: tag, page: page, id:''}
        await this.api.axiosGql("SELECT_DELIVERY_INFO", param) 
        .then(async (res) => { 
          let result = res.data
          if(result.length === 0) {
            alert(`${this.t('sentence.wrongInfo68')}`)
            if(page > 1) this.page--
            return
          } else {
            this.page = page
            var orderArray = new Array()
            result.map(order => { 
              orderArray.push(JSON.stringify(order))
            })
            let ordersJson = JSON.parse(JSON.stringify(orderArray))
            this.orders = Object.keys(ordersJson).map( (key) => {
              let order = JSON.parse(ordersJson[key])
              this.date = order.range
              return order
            })
            this.groupByUid()
            
            this.estimate3Key++
          }
        })
        .catch((error) => { 
          alert(error);
          console.log(error);
        }) 
        .finally(() => { 
          if(!(tag === 0 || tag === undefined)) 
            this.api.axiosGql('INSERT_STAT_KEYWORD', {type:'INSERT_STAT_KEYWORD', searchType:'1', keyword:tag, opt:country, mail:this.api.getCookies('mail')})
          
          this.emitter.emit('dialog', {flag:false, title:'Loading'})
        })
      }
    },
    async refresh() {
      this.orders = ref([])
      this.groupingOrders.clear()
      this.estimate3Key++
      this.deliverycKey++
      this.page = 1
    },
    async groupByUid() {
      this.groupingOrders.clear()
      this.orders.map( (order) => {
        let uid = order.UID
        order.COUNTRY = this.api.getCountryName({country:order.COUNTRY})
        order.COUNTRY2 = this.api.getCountryName({country:order.COUNTRY2})
        if(this.groupingOrders.has(uid)) {
          let valueList = this.groupingOrders.get(uid)
          let deliveryPrice2 = this.totalDeliveryPrice.get(uid)
          deliveryPrice2 += parseInt(order.DELIVERY_PRICE2)
          this.totalDeliveryPrice.set(uid, deliveryPrice2)
          valueList.push(order)
          this.groupingOrders.set(uid, valueList)
        } else {
          this.totalDeliveryPrice.set(uid, order.DELIVERY_PRICE2)
          this.groupingOrders.set(uid, [order])
        }
      })
      this.deliverycKey++
    },
    async setOrder(orders) {
      this.orders = orders
      await this.groupByUid()
      this.estimate3Key++
      this.page = 1
    },
    async paging(type) {
      if(this.groupingOrders.size === 0) {
        alert(`${this.t('sentence.wrongInfo69')}`)
        return
      } 
      if(type === 'prev') {
        if(this.page === 1) {
          alert(`${this.t('sentence.firstPage')}`)
          return
        } else this.page -= 1
      } else this.page += 1
      this.search(this.page)
      const el = document.getElementById('select_delivery')
      el.scrollIntoView()
    }    
  }
}
</script>

<style scoped>
td {
  padding: 0px;
}
#tag {
  width: 100%;
}
#select_delivery {
  width: 100%;
  min-width: 100px;
  text-align: center;
}
input {
  width: auto;
}
</style>
